//@ts-ignore we need this react import for type inference
import React from 'react';
import { Col } from 'antd';
import styled from 'styled-components';

const Container = styled.div<{ borderColor: string }>`
    position: relative;
    display: flex;
    flex-direction: column;
    font-family: 'Open Sans', sans-serif;
    width: 100%;
    height: 100%;
    border: 1px solid ${({ borderColor }) => borderColor};
    border-radius: 0;
    z-index: 0;

    &::after {
        content: '';
        position: absolute;
        border: 1px solid ${({ borderColor }) => borderColor};
        width: 100%;
        height: 100%;
    }
`;

const WarningBoxSummaryWrapper = styled.div<{ fontSize: number }>`
    overflow: unset;

    > div {
        font-size: ${({ fontSize }) => fontSize}%;
    }
`;

const WarningBoxAlertWrapper = styled.div<{ fontSize: number; color: string }>`
    font-size: ${({ fontSize }) => fontSize}%;
    text-align: left;
    border-radius: 0;
    border: none;

    .ant-alert-with-description {
        line-height: 1.2;
    }

    .ant-alert-description {
        padding: 0 15px 0 0;
    }

    * .ant-alert,
    .ant-alert-message,
    .anticon,
    .ant-alert-with-description {
        font-size: ${({ fontSize }) => fontSize * 1.1}%;
        color: ${({ color }) => color} !important;
        font-weight: bold;
        line-height: 1.2;
    }
`;

const WarningCardContainer = styled(Col)<{ fontSize: number }>`
    font-size: ${({ fontSize }) => fontSize}%;
    height: 100%;
`;

export { Container, WarningBoxAlertWrapper, WarningBoxSummaryWrapper, WarningCardContainer };
